export const LOCATION_REQUIREMENT_WARNING =
  "You don’t meet the location requirement for this job. Your chances of getting an offer are low.";
export const TIMEZONE_REQUIREMENT_WARNING =
  "Please note the timezone requirements listed above before applying.";
